import {
  CLEAR_ERRORS_ENGAGEMENTS_ATTACHMENTS,
} from 'pages/WirelineEngagements/WirelineEngagementsAttachments/ClearErrorsAttachments/actionTypes';

export const clearErrorsAttachments = (attachments) => (
  { type: CLEAR_ERRORS_ENGAGEMENTS_ATTACHMENTS, attachments });
